import styled from 'styled-components';
import C from '@assets/themes/colors';

export const FontFamilyContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

